// 字体路径测试工具
class FontPathTester {
  constructor() {
    this.testResults = [];
  }

  // 测试不同的字体路径
  async testFontPaths() {
    const testPaths = [
      // webpack别名路径
      '@/assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2',
      '~@/assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2',
      
      // 相对路径
      'assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2',
      '../assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2',
      './assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2',
      
      // 绝对路径（开发服务器）
      '/assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2',
      
      // 其他可能的路径
      'src/assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2',
      '/src/assets/fonts/AlibabaPuHuiTi-3-55-Regular/AlibabaPuHuiTi-3-55-Regular.woff2'
    ];

    console.log('=== 字体路径测试 ===');
    
    for (const path of testPaths) {
      try {
        const response = await fetch(path);
        const result = {
          path: path,
          exists: response.ok,
          status: response.status,
          statusText: response.statusText,
          size: response.headers.get('content-length')
        };
        
        this.testResults.push(result);
        console.log(`✅ ${path}: ${response.ok ? '成功' : '失败'} (${response.status})`);
      } catch (error) {
        const result = {
          path: path,
          exists: false,
          error: error.message
        };
        
        this.testResults.push(result);
        console.log(`❌ ${path}: 失败 (${error.message})`);
      }
    }

    // 显示最佳路径
    const workingPaths = this.testResults.filter(result => result.exists);
    if (workingPaths.length > 0) {
      console.log('\n=== 可用的字体路径 ===');
      workingPaths.forEach(result => {
        console.log(`✅ ${result.path} (${result.status})`);
      });
    } else {
      console.log('\n❌ 没有找到可用的字体路径');
    }

    return this.testResults;
  }

  // 测试字体文件是否存在
  async testFontFileExists() {
    const testFile = 'AlibabaPuHuiTi-3-55-Regular.woff2';
    const possiblePaths = [
      'assets/fonts/AlibabaPuHuiTi-3-55-Regular/',
      'src/assets/fonts/AlibabaPuHuiTi-3-55-Regular/',
      '../assets/fonts/AlibabaPuHuiTi-3-55-Regular/',
      './assets/fonts/AlibabaPuHuiTi-3-55-Regular/',
      '/assets/fonts/AlibabaPuHuiTi-3-55-Regular/',
      '/src/assets/fonts/AlibabaPuHuiTi-3-55-Regular/'
    ];

    console.log('\n=== 字体文件存在性测试 ===');
    
    for (const basePath of possiblePaths) {
      const fullPath = basePath + testFile;
      try {
        const response = await fetch(fullPath);
        console.log(`${fullPath}: ${response.ok ? '✅ 存在' : '❌ 不存在'} (${response.status})`);
      } catch (error) {
        console.log(`${fullPath}: ❌ 错误 (${error.message})`);
      }
    }
  }

  // 检查当前页面的字体加载
  checkCurrentFontLoading() {
    console.log('\n=== 当前页面字体加载状态 ===');
    
    // 检查@font-face规则
    const styleSheets = Array.from(document.styleSheets);
    let fontFaceCount = 0;
    
    styleSheets.forEach((sheet, index) => {
      try {
        const rules = Array.from(sheet.cssRules || sheet.rules);
        rules.forEach(rule => {
          if (rule instanceof CSSFontFaceRule) {
            fontFaceCount++;
            console.log(`@font-face规则 ${fontFaceCount}:`);
            console.log(`  字体族: ${rule.style.getPropertyValue('font-family')}`);
            console.log(`  字重: ${rule.style.getPropertyValue('font-weight')}`);
            console.log(`  源: ${rule.style.getPropertyValue('src')}`);
          }
        });
      } catch (error) {
        console.warn(`无法访问样式表 ${index}:`, error);
      }
    });

    if (fontFaceCount === 0) {
      console.log('❌ 未找到@font-face规则');
    } else {
      console.log(`✅ 找到 ${fontFaceCount} 个@font-face规则`);
    }

    // 延迟检查字体加载状态（给字体时间加载）
    if (document.fonts && document.fonts.check) {
      setTimeout(() => {
        const alibabaLoaded = document.fonts.check('12px "Alibaba PuHuiTi"');
        console.log(`阿里普惠字体加载状态: ${alibabaLoaded ? '✅ 已加载' : '❌ 未加载'}`);
      }, 2000); // 2秒后检测
    }
  }

  // 运行完整测试
  async runFullTest() {
    console.log('开始字体路径完整测试...\n');
    
    await this.testFontPaths();
    await this.testFontFileExists();
    this.checkCurrentFontLoading();
    
    console.log('\n=== 测试完成 ===');
    return this.testResults;
  }
}

// 导出实例
export const fontPathTester = new FontPathTester();

// 默认导出
export default FontPathTester; 